<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Crear / Editar -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_escolaridad === null ? "Crear" : "Editar" }} Escolaridad
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn
            color="red"
            text
            @click="saveDialogAddEdit"
            :loading="loadingSave"
          >Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Escolaridad</v-card-title>

        <v-card-text>
          ¿Está seguro de que desea eliminar la escolaridad llamada
          "{{ editedItem.nombre }}"? Esta acción es permanente y no se puede revertir.
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn
            color="red"
            text
            @click="saveDialogDelete"
            :loading="loadingDelete"
          >Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón crear -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Escolaridad
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :items-per-page="-1"
          hide-default-footer
          class="elevation-1"
        >
          <!-- BODY con draggable (Vuetify 2) -->
          <template v-slot:body="props">
            <draggable
              v-model="items"
              tag="tbody"
              handle=".drag-handle"
              :disabled="loading || loadingSave || loadingDelete"
              @end="ordenarEscolaridad"
            >
              <tr v-for="item in props.items" :key="item.id_escolaridad">
                <td class="text-center" style="width: 10%;">
                  <v-icon
                    small
                    class="mr-2 drag-handle"
                    title="Arrastrar para ordenar"
                    style="cursor: grab;"
                  >
                    mdi-drag
                  </v-icon>
                </td>
                <td class="text-center" style="width: 80%;">
                  {{ item.nombre }}
                </td>

                <td class="text-center" style="width: 10%;">
                  <v-icon small class="mr-2" @click="openDialogAddEdit(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small class="mr-2" @click="openDialogDelete(item)">
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
            </draggable>
          </template>

          <template v-slot:no-data>
            <div class="pa-4 text-center">No hay escolaridades.</div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";
import draggable from "vuedraggable"; // npm i vuedraggable@2

export default {
  components: {
    VAlertDialog,
    draggable
  },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,

    loading: false,
    loadingSave: false,
    loadingDelete: false,

    items: [],
    headers: [
      {
        text: "",
        value: "order",
        align: "center",
        width: "10%",
        sortable: false
      },
      {
        text: "Escolaridad",
        value: "nombre",
        align: "center",
        width: "80%",
        sortable: false
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%",
        sortable: false
      }
    ],

    editedItem: {
      id_escolaridad: null,
      nombre: ""
    },
    defaultEditedItem: {
      id_escolaridad: null,
      nombre: ""
    }
  }),
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      axios
        .get("/Catalogos/ListarEscolaridades")
        .then((response) => {
          this.items = response.data || [];
        })
        .catch((error) => {
          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al cargar las escolaridades.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDialogAddEdit(editItem = null) {
      if (editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);

      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    saveDialogAddEdit() {
      if (
        this.editedItem.nombre == null ||
        this.editedItem.nombre.length === 0 ||
        this.editedItem.nombre.length > 256
      ) {
        this.$refs.alert.setMessage("", "Debe de ingresar un Nombre entre 1 y 256 caracteres");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      const isCreate = this.editedItem.id_escolaridad === null;

      axios({
        method: isCreate ? "POST" : "PUT",
        url: isCreate
          ? "/Catalogos/CrearEscolaridad"
          : `/Catalogos/EditarEscolaridad/${this.editedItem.id_escolaridad}`,
        data: {
          nombre: this.editedItem.nombre
        }
      })
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch((error) => {
          if (error?.response?.status === 409) {
            this.$refs.alert.setMessage("", "Ya existe una Escolaridad con el mismo Nombre.");
            this.$refs.alert.open();
            return;
          }

          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al guardar la escolaridad.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },

    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },

    saveDialogDelete() {
      if (this.editedItem.id_escolaridad == null) return;

      this.loadingDelete = true;
      axios
        .delete(`/Catalogos/EliminarEscolaridad/${this.editedItem.id_escolaridad}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch((error) => {
          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al eliminar la escolaridad.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },

    // Se dispara al soltar el drag
    ordenarEscolaridad() {
      this.loading = true;

      const orden = (this.items || []).map((x, index) => ({
        id_escolaridad: x.id_escolaridad,
        posicion: index + 1
      }));

      axios
      .post('/Catalogos/OrdenarEscolaridad', orden)
      .then(() => {
        this.getItems()
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false;
      })
    },
  }
};
</script>

<style scoped>
.drag-handle {
  user-select: none;
}
</style>
